import { Module } from 'vuex';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';
import { RootState } from '@/interface/store';
import { Auth } from '@/interface/store/auth';

const user = JSON.parse(<string>localStorage.getItem('users')) || {};

export const initialState = () => {
  return {
    isEmail: false,
    isRegister: {},
    isAuth: !!user.id,
    id: user.id || '',
    fullName: user.fullName || '',
    email: user.email || '',
    phoneNumber: user.phoneNumber || '',
    organization: user.organization || '',
    lastGroupId: user.lastGroupId || null,
    avatar: user.fkUserAvatars || {},
    settings: user.settings || {},
    emailSettings: user.emailSettings || {},
    subscribedToNewsletters: user.subscribedToNewsletters || false,
  };
};

export const state: Auth = initialState();

const namespaced: boolean = true;

export const auth: Module<Auth, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};
